<div class="page-wrap">
  <div class="panel">
    <label>Subject</label>
    <input type="text" [(ngModel)]="templateData.subject" />
  </div>

  <div class="panel toolbar" style="justify-content: center;">
    <div class="ed_title">EDITOR TOOLS</div>
    <button type="button" (click)="exec('bold')"><b>B</b></button>
    <button type="button" (click)="exec('italic')"><i>I</i></button>
    <button type="button" (click)="exec('underline')"><u>U</u></button>

    <button type="button" (click)="alignText('left')">Left</button>
    <button type="button" (click)="alignText('center')">Center</button>
    <button type="button" (click)="alignText('right')">Right</button>


    <div class="editor-tools">
      <select (change)="setFontSize($event.target.value)" style="width: 90px;margin: 0; cursor: pointer;">
        <option value="14">14</option>
        <option value="16" selected>16</option>
        <option value="18">18</option>
        <option value="20">20</option>
        <option value="24">24</option>
      </select>

      <input type="color" (change)="setTextColor($event.target.value)"
        style="width: 58px;padding: 0;cursor: pointer;margin: 0;" />

      <button type="button" (click)="insertButtonPlaceholder()" *ngIf="insertBtnFlag">Insert Button</button>

      <button type="button" (click)="insertAppStoreButtonPlaceholder()">Insert App Store
        Button</button>

      <button type="button" (click)="insertCredentials()" *ngIf="template_id == 5">Add Credentials</button>

      <div class="form-check form-switch" style="display: flex;align-items: center; gap: 5px; margin-left: 10px; " *ngIf="template_id == 4">
        <input class="form-check-input" type="checkbox" role="switch" id="attachQRCode" style="width: 32px; height: 16px;" [(ngModel)]="attachQRCode">
        <label class="form-check-label" for="attachQRCode" style="margin-bottom: 6px;">Attach QR Code</label>
      </div>
    </div>

  </div>

  <div class="panel">
    <label>Text Editor</label>
    <div #editor class="editor-box" contenteditable="true" (input)="syncContent()" (keydown)="onEditorKeydown($event)">
    </div>
  </div>

  <div class="panel button-settings">
    <h3>Button Settings</h3>

    <label>Button Text</label>
    <input type="text" [(ngModel)]="templateData.buttonText" (input)="updateButtonPlaceholders()" />

    <div class="editor-tools button-color">

      <label>Background Color</label>
      <input type="color" [(ngModel)]="templateData.buttonBgColor" (change)="updateButtonPlaceholders()" />

      <label>Text Color</label>
      <input type="color" [(ngModel)]="templateData.buttonTextColor" (change)="updateButtonPlaceholders()" />

      <label>Border Color</label>
      <input type="color" [(ngModel)]="templateData.buttonBorderColor" (change)="updateButtonPlaceholders()" />

    </div>

    <div class="editor-tools">
      <label>Border Radius</label>
      <input type="number" [(ngModel)]="templateData.buttonBorderRadius" (input)="updateButtonPlaceholders()" />

      <label>Padding Y</label>
      <input type="number" [(ngModel)]="templateData.buttonPaddingY" (input)="updateButtonPlaceholders()" />

      <label>Padding X</label>
      <input type="number" [(ngModel)]="templateData.buttonPaddingX" (input)="updateButtonPlaceholders()" />

    </div>

    <div class="editor-tools">
      <label>Button Align</label>
      <select [(ngModel)]="templateData.buttonAlign">
        <option value="left">Left</option>
        <option value="center">Center</option>
        <option value="right">Right</option>
      </select>


      <label>Button CTA</label>
      <select [(ngModel)]="templateData.buttonCTA">
        <option value="link_menu_upload">Link Menu Upload URL</option>
      </select>
    </div>
  </div>



  <div class="panel">
    <h3>Email Preview</h3>
    <iframe #previewFrame *ngIf="previewHtml" [srcdoc]="previewHtml" class="preview-frame"></iframe>
  </div>


  <div class="panel" style="text-align: center;">
    <!-- <button type="button" (click)="generatePreview()">Preview</button> -->
    <button type="button" (click)="saveTemplate()">Save Template</button>
  </div>
</div>